import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const neonTech = defineConnector({
  identifier: "neonTech",
  name: "Neon",
  tagLine: "Serverless Postgres platform",
  logo,
  protocol: "http",
  tags: ["data", "engineering"],
  defaultUrlPattern: () => "https://console\\.neon\\.tech/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Neon Console > Account Settings > API Keys](https://console.neon.tech/app/settings/api-keys) and create a new API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://console.neon.tech/api/v2/projects",
  },
});
